import React from "react";
import { TrendingUp } from "lucide-react";

const MarketApproach = () => {
  const revenue = 2600000;
  const revenueMultiple = 1.8;
  const estimatedRevenueValue = revenue * revenueMultiple;

  const ebitda = 690000;
  const ebitdaMultiple = 7.5;
  const estimatedEbitdaValue = ebitda * ebitdaMultiple;

  return (
    <div className="p-6 bg-white shadow rounded-xl mb-6">
      <div className="flex items-center mb-4">
        <TrendingUp className="h-6 w-6 text-pink-500 mr-2" />
        <h3 className="text-lg font-medium text-gray-900">Market Approach</h3>
      </div>
      <p className="text-gray-700 mb-4">
        The Market Approach determines value based on comparable businesses within the same industry.
      </p>
      <div className="mb-6">
        <h3 className="text-xl font-semibold">Comparable Transactions Analysis:</h3>
        <p className="text-gray-700">
          We identified food truck businesses with similar revenue and growth trends that have been acquired recently.
        </p>
        <p className="text-gray-700">
          The median revenue multiple (EV/Revenue) in the fast-casual sector is {revenueMultiple}x.
        </p>
        <p className="text-gray-700 font-bold">
          Estimated Value = ${revenue.toLocaleString()} × {revenueMultiple} = ${estimatedRevenueValue.toLocaleString()}
        </p>
      </div>
      <div className="mb-6">
        <h3 className="text-xl font-semibold">Comparable Public Companies Analysis:</h3>
        <p className="text-gray-700">
          Publicly traded food service companies with similar models have an EBITDA multiple (EV/EBITDA) of {ebitdaMultiple}x.
        </p>
        <p className="text-gray-700 font-bold">
          Estimated Value = ${ebitda.toLocaleString()} × {ebitdaMultiple} = ${estimatedEbitdaValue.toLocaleString()}
        </p>
      </div>
      <div className="mt-4 p-4 bg-gray-100 rounded-lg">
        <h3 className="text-lg font-semibold">Market Approach Valuation Range:</h3>
        <p className="text-gray-800 font-bold">
          ${estimatedRevenueValue.toLocaleString()} - ${estimatedEbitdaValue.toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default MarketApproach;